module.exports = __webpack_public_path__ + "static/media/caminhao.5d24db37.svg";